import type { ConnectedServiceStatusDto } from "../../../common/model/connectedServiceStatusDto";
import type { SyncStatus } from "../../../common/model/syncStatus";
import { FIRST_HIGHWATER_MARK_FOR_STRAVA } from "../constants";
import { DataSync } from "./dataSync";
import { DataSyncProcessed } from "./dataSyncProcessed";

export default class ConnectedServiceStatus {
  constructor(
    public ongoingDataSync?: DataSync,
    public latestDataSync?: DataSyncProcessed,
  ) {}

  public lastFinishTime(): Date | undefined {
    if (!this.latestDataSync) {
      return undefined;
    }
    return this.latestDataSync.finished;
  }

  public lastHighWaterMark(): number {
    if (!this.latestDataSync) {
      return FIRST_HIGHWATER_MARK_FOR_STRAVA;
    }
    return this.latestDataSync.highWaterMark;
  }

  public synchronizationStatus(): SyncStatus {
    if (!this.latestDataSync) {
      return "NOT_STARTED";
    }
    return this.latestDataSync.status ?? "NOT_STARTED";
  }

  public lastError(): string {
    if (!this.latestDataSync) {
      return "";
    }
    return this.latestDataSync.error || "";
  }

  static fromDto(dto: ConnectedServiceStatusDto): ConnectedServiceStatus {
    return new ConnectedServiceStatus(
      dto.ongoingDataSync ? DataSync.fromDto(dto.ongoingDataSync) : undefined,
      dto.latestDataSync ? DataSyncProcessed.fromDto(dto.latestDataSync) : undefined,
    );
  }
}
